export class LanguageModel {
  title = ''
  langId = ''
  flag = ''
  code = ''
}
